/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.detail.upsells.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.userPreferences'
])

.controller('ProgramsDetailUpsellsController', ['$scope', '$timeout', 'ResolveViewData', 'ResolveTemplatesData', 'ApiService', 'HelpersService', 'UserPreferencesService', function($scope, $timeout, ResolveViewData, ResolveTemplatesData, ApiService, HelpersService, UserPreferencesService) {

  var updateTimer;

  $scope.programsDetailUpsells = {
    
    isAdding: false,

    model: {},
    program: {},

    search: {},
    savedSummaries: [],
    summaries: [],
    templates: [],

    currentUpsell: {},
    
    dateFormat: UserPreferencesService.getDateFormat('standardDate', 'dateFormat'),
    strip: HelpersService.strip,

    init: function() {
      if (ResolveViewData.data && ResolveViewData.data.success) {
        this.success.init(ResolveViewData);
      }else{
        this.error.init(ResolveViewData);
      }

      if (ResolveTemplatesData.data && ResolveTemplatesData.data.success) {
        this.success.initSummaries(ResolveTemplatesData);
      }else{
        this.error.initSummaries(ResolveTemplatesData);
      }

    },

    showTemplates: function() {
      this.isAdding = true;
    },

    hideTemplates: function() {
      this.isAdding = false;
    },

    toggleTemplates: function() {
      this.isAdding = !this.isAdding;
    },

    moveUp: function(index) {
      var moved = this.templates.splice(index, 1);
      this.templates.splice(index - 1, 0, moved[0]);
      this.save();
    },

    moveDown: function(index) {
      var moved = this.templates.splice(index, 1);
      this.templates.splice(index + 1, 0, moved[0]);
      this.save();
    },

    getRecoStub: function() {
      return {
        eventTemplateId: '',
        min: {
          days: 0,
          hours: 0,
          minutes: 1
        },
        max: {
          days: 365,
          hours: 0,
          minutes: 0
        }
      };
    },

    findSummary: function(id) {
      var i, ii,
        r = false;

      for (i=0,ii=this.savedSummaries.length;i<ii;i++) {
        if (this.savedSummaries[i].id === id) {
          r = this.savedSummaries[i];
          break;
        }
      }

      return r;
    },

    addTemplate: function(id) {
      var i, ii,
        j, jj,
        merged = {};

      for(i=this.summaries.length-1,ii=0;i>=ii;i--) {
        if (this.summaries[i].id === id) {
          merged = this.summaries.splice(i, 1)[0];
          for(j=0,jj=this.model.recommendations.length;j<jj;j++) {
            if (this.model.recommendations[j].eventTemplateId === id) {
              HelpersService.decorate(merged, this.model.recommendations[j]);
              break;
            }
          }
          this.templates.push(merged);
        }
      }
    },

    stripExisting: function(templates) {

      var i, ii,
          j, jj,
          merged = {};


      if (this.hasUpsells()) {
        for (j = 0, jj = this.model.recommendations.length; j < jj; j++) {
          for (i = templates.length - 1, ii = 0; i >= ii; i--) {
            console.log('ProgramsDetailUpsellsController::stripExisting', templates[i].id, this.program.id );
            if (templates[i].id === this.program.id) {
              templates.splice(i, 1);
              continue;
            }

            if (templates[i].id === this.model.recommendations[j].eventTemplateId) {
              // Load templates which already exist
              console.log('ProgramsDetailUpsellsController::stripExisting', templates[i].id);
              merged = templates.splice(i, 1)[0];
              HelpersService.decorate(merged, this.model.recommendations[j]);
              this.templates.push(merged);
            }
          }
        }
      }else{
        for (i=0,ii=templates.length;i<ii;i++) {
          if (templates[i].id === this.program.id) {
            templates.splice(i, 1);
            break;
          }
        }
      }

      console.log('ProgramsDetailUpsellsController::stripExisting', this.templates);

      return templates;

    },

    pruneTemplates: function() {
      var i, ii,
        j, jj,
        tmp = [];

      for (j=0,jj=this.model.recommendations.length;j<jj;j++) {
        for (i=0,ii=this.templates.length;i<ii;i++) {
          if (this.templates[i].id === this.model.recommendations[j].eventTemplateId) {
            tmp.push(this.templates[i]);
            break;
          }
        }
      }
      console.log('ProgramsDetailUpsellsController::pruneTemplates', tmp);

      this.templates = tmp.slice(0);
    },

    hasUpsells: function() {
      return (this.model && this.model.recommendations instanceof Array && this.model.recommendations.length > 0);
    },

    add: function(id) {

      this.currentUpsell = this.getRecoStub();

      this.currentUpsell.eventTemplateId = id;

      if (!this.model) {
        this.model = {
          recommendations: [this.currentUpsell],
          tags: []
        };
        $scope.programsDetailUpsells.create();
      }else{
        this.model.recommendations.push(this.currentUpsell);
        $scope.programsDetailUpsells.update();
      }
      this.addTemplate(id);

    },

    create: function() {
      ApiService.program.recommendations.create(this.program.id, this.model).then(this.success.create, this.error.create);
    },

    remove: function(id) {
      var i, ii,
          removed = {};

      if (this.hasUpsells()) {

        for (i=0,ii=this.model.recommendations.length;i<ii;i++) {
          console.log('ProgramsDetailUpsellsController::remove', (id === this.model.recommendations[i].eventTemplateId));
          if (this.model.recommendations[i].eventTemplateId === id) {
            console.log('ProgramsDetailUpsellsController::remove', this.model.recommendations[i].eventTemplateId);
            removed = this.model.recommendations.splice(i, 1);
            this.summaries.push(this.findSummary(removed[0].eventTemplateId));
            break;
          }
        }
        console.log('ProgramsDetailUpsellsController::remove', this.model.recommendations);

        // If we've removed the last prerequisite we must clear the entire object
        // Otherwise we can simply update
        if (this.hasUpsells()) {
          ApiService.program.recommendations.update(this.program.id, this.model).then(this.success.remove, this.error.remove);
        }else {
          ApiService.program.recommendations.remove(this.program.id).then(this.success.remove, this.error.remove);
        }
      }
    },

    update: function() {
      console.log('ProgramsDetailUpsellsController::update', this.model);
      ApiService.program.recommendations.update(this.program.id, this.model).then(this.success.update, this.error.update);
    },

    save: function() {
      var i, ii,
          j, jj,
          saved = [];
      console.log('ProgramsDetailDependentsController::save', this.model.recommendations);

      for (i=0,ii=this.templates.length;i<ii;i++) {
        for (j=0,jj=this.model.recommendations.length;j<jj;j++) {
          if (this.templates[i].id === this.model.recommendations[j].eventTemplateId) {
            this.model.recommendations[j].max = this.templates[i].max;
            this.model.recommendations[j].min = this.templates[i].min;
            saved.push(this.model.recommendations[j]);
            break;
          }
        }
      }

      this.model.recommendations = saved;

      console.log('ProgramsDetailUpsellsController::save', this.model.recommendations);

      this.update();

    },

    success: {
      init: function(response) {
        console.log('ProgramsDetailUpsellsController::success::init', response);
        if (!response.data.payload) { return; }
        $scope.programsDetailUpsells.program = response.data.payload;
        $scope.programsDetailUpsells.model = $scope.programsDetailUpsells.program.recommendations;
      },

      initSummaries: function(response) {
        console.log('ProgramsDetailUpsellsController::success::initTemplates', response);
        if (!response.data.payload.list) { return; }
        $scope.programsDetailUpsells.savedSummaries = response.data.payload.list.slice(0);
        $scope.programsDetailUpsells.summaries = $scope.programsDetailUpsells.stripExisting(response.data.payload.list);
      },

      create: function(response) {
        $scope.programsDetailUpsells.hideTemplates();
        $scope.programsDetailUpsells.addTemplate($scope.programsDetailUpsells.currentUpsell.eventTemplateId);
        $scope.programsDetailUpsells.currentUpsell = {};
      },
      remove: function(response) {
        $scope.programsDetailUpsells.pruneTemplates();
      },
      update: function(response) {
        $scope.programsDetailUpsells.success.create(response);
      }

    },

    error: {
      init: function(response) {},
      initSummaries: function(response) {},
      getTemplate: function(response) {},

      create: function(response) {},
      remove: function(response) {},
      update: function(response) {}
    },

    onDestroy: function() {
      $timeout.cancel(updateTimer);
      $scope.programsDetailUpsells.save();
    },

    onFieldBlur: function(e) {
      console.log('ProgramsDetailUpsellsController::onTemplatesUpdate', e);

      if (updateTimer) {
        $timeout.cancel(updateTimer);
      }
      updateTimer = $timeout(function() {
        $scope.programsDetailUpsells.save();
      }, 1000);
    }

  };

  $scope.programsDetailUpsells.init();


}]);